import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "./styles/tokens.css";
import "./styles/styles.css";
import { AuthProvider } from "./lib/auth";
import { ThemeProvider } from "./lib/useTheme";
import { DisplayProvider } from "./lib/useDisplay";
import { runLiveUpdate } from "./lib/liveUpdate";
import { adoptPathLink } from "./lib/shareUrl";
import { App } from "./App";

// Check for over-the-air updates on startup (native only; no-op on web).
void runLiveUpdate();

// Public recipe links are plain paths so they can unfurl in iMessage (see
// lib/shareUrl.ts). Put the route back on the hash before HashRouter reads it.
adoptPathLink();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ThemeProvider>
        <DisplayProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </DisplayProvider>
      </ThemeProvider>
    </HashRouter>
  </React.StrictMode>
);
